import {
  InternalPhoneNumberAdminViewDto,
  TeamAdminViewDto,
} from '@act/shared/data-transfer-objects';
import { ColumnConfiguration } from '@act/storybook';
import { timeFormatter } from '@act/shared/utilities';

export const TeamsTableColumns = (
  internalNumbers: InternalPhoneNumberAdminViewDto[]
): ColumnConfiguration<TeamAdminViewDto>[] => [
  {
    id: 'name',
    value: (props: TeamAdminViewDto) => `${props.name}`,
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Name',
  },
  {
    id: 'internalPhoneNumberId',
    value: (props: TeamAdminViewDto) => {
      const number = internalNumbers.find(
        number => number.id === props.internalPhoneNumberId
      );
      return number?.displayName
        ? `${number?.displayName}`
        : `${number?.description}`;
    },
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Phone number',
  },
  {
    id: 'createdAt',
    value: (props: TeamAdminViewDto) =>
      `${timeFormatter.epochToShortDate(props.createdAt)}`,
    isNumeric: true,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Created on',
  },
];
